<script>

import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import {useStore} from "vuex";
// import router from "@/router";

import router from "@/router";

export default {
  name: "SplashPage",
  setup() {

    let store = useStore()
    let sid = localStorage.getItem('sid')

    let version = '1.0.5'


    function check_version() {
      FreeWorld.Heisenberg({action:'info'} , 'info').then((res)=>{

        if (res.data.upadting == 1){
          Swals.Updating()
        }else if (version !== res.data.version){
          Swals.NewVersion()
        }else{
          store.commit('set_info', res.data)
          if (sid != null) {

            run_app()

          } else {

            setTimeout(() => {
              router.push({name: 'LoginPage'})
            }, 3000)

          }
        }

      }).catch((res) => {
        Swals.Catch(res, check_version, true)
      })

    }
    check_version()


    function run_app() {

          FreeWorld.Heisenberg({}, 'shop/homepage', true).then((res) => {

            store.commit('set_HomePage', res.data)

            FreeWorld.Heisenberg({action: 'profile'}, 'info', true).then((res) => {

              let data = res.data
              delete(data.bid)
              delete(data.ch)
              delete(data.created_at)
              delete(data.updated_at)
              delete(data.id)
              delete(data.panel)
              delete(data.rate)
              delete(data.status)
              delete(data.wallet)
              delete(data.company_edate)
              delete(data.company_site)
              delete(data.company_username)
              store.commit('set_Profile', data)

              FreeWorld.Heisenberg({action: 'cards'}, 'info', true).then((res) => {

                store.commit('set_Cards', res.data.cards)


                setTimeout(() => {
                  router.push({name: 'HomePage'})
                }, 3000)


              }).catch((res) => {
                Swals.Catch(res, run_app, true)
              })

            }).catch((res) => {
              Swals.Catch(res, run_app, true)
            })

          }).catch((res) => {
            Swals.Catch(res, run_app, true)
          })
    }

    return {}

  }

}
</script>


<template>

  <div id="main" class="bg-color d-flex flex-column align-items-center justify-content-center">

    <img class="img_logo" src="../assets/img/logo.png" alt="">

    <br>
    <br>
    <br>

    <div class="waviy">

      <span class="text-white" style="--i:1">S</span>
      <span class="text-white" style="--i:2">H</span>
      <span class="text-white" style="--i:3">O</span>
      <span class="text-white" style="--i:4">P</span>
      <span class="text-white" style="--i:5">M</span>
      <span class="text-white" style="--i:6">A</span>
      <span class="text-white" style="--i:7">R</span>
      <span class="text-white" style="--i:8">K</span>
      <span class="text-white" style="--i:9">E</span>
      <span class="text-white" style="--i:10">T</span>
      <span class="text-white" style="--i:11">.</span>
      <span class="text-white" style="--i:12">.</span>
      <span class="text-white" style="--i:13">.</span>

    </div>

  </div>


</template>


<style scoped>

.img_logo {
  height: 300px;
}

.waviy {
  position: relative;
  -webkit-box-reflect: below -20px linear-gradient(transparent, rgba(0, 0, 0, .2));
  display: flex;
  flex-direction: row-reverse;
}

.waviy span {
  font-family: logo;
  position: relative;
  display: inline-block;
  font-size: 30px;
  color: #fff;
  text-transform: uppercase;
  animation: waviy 1s infinite;
  animation-delay: calc(.1s * var(--i));
}

@keyframes waviy {
  0%, 40%, 100% {
    transform: translateY(0)
  }
  20% {
    transform: translateY(-20px)
  }
}

</style>